import React, { lazy, Suspense } from 'react';
var MediaPlayerLazy = /*#__PURE__*/lazy(function () {
  return import('./index.lazy');
});
var MediaPlayer = function MediaPlayer(props) {
  return /*#__PURE__*/React.createElement(Suspense, null, /*#__PURE__*/React.createElement(MediaPlayerLazy, props));
};
export default MediaPlayer;